import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useDeleteAllPrepaidCards from './hooks/useDeleteAllPrepaidCards';

const DeleteAllPrepaidCardsModal: ActivityComponentType = () => {
  const { pop } = useFlow();
  const { handleDeleteAllPrepaidCards } = useDeleteAllPrepaidCards();
  return (
        <Modal>
            <ModalContainer>
                <Column spacing={36} align='center'>
                    <Text align='center' size='xl'>
                        등록된 선불카드 전체를<br/>삭제할까요?
                    </Text>
                    <Column fullWidth spacing={10}>
                        <Button variant='secondary'
                                fullWidth
                                onClick={pop}>
                            취소
                        </Button>
                        <Button fullWidth onClick={handleDeleteAllPrepaidCards}>
                            삭제하기
                        </Button>
                    </Column>
                </Column>
            </ModalContainer>
        </Modal>
  );
};

export default DeleteAllPrepaidCardsModal;
